import useCreateOrUpdatePractice from './useCreateOrUpdatePractice';
import useDeletePractice from './useDeletePractice';
import useGetPosts from './useGetPosts';
import useGetPracticeById from './useGetPracticeById';
import useGetPractices from './useGetPractices';
import useRunPractice from './useRunPractice';

import { useMutation, useQueryClient } from '@tanstack/react-query';
import PracticeService from 'Src/services/practice-service';
import { ConversationPost } from 'Src/types/agent';

const useAddToConversation = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      practiceId,
      posts,
    }: {
      practiceId: number;
      posts: ConversationPost;
    }) => PracticeService.addToConversation(practiceId, posts),
    onSuccess: (_, { practiceId }) => {
      // Invalidate and refetch the practice posts after adding to conversation
      onSuccess?.();
      // The practice now has posts, so it belongs in Recent Chats.
      queryClient.invalidateQueries({ queryKey: ['practices', 'list'] });
      // queryClient.invalidateQueries({
      //   queryKey: ['practice', practiceId, 'posts'],
      // });
      // queryClient.removeQueries({ queryKey: ['posts', practiceId] });
    },
  });
};

export {
  useAddToConversation,
  useCreateOrUpdatePractice,
  useDeletePractice,
  useGetPosts,
  useGetPracticeById,
  useGetPractices,
  useRunPractice,
};
